import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import addUserValidation from "../../constant/validations/form.validation.messages";

const validation = Yup.object().shape({
    name: Yup.string().required(addUserValidation.amenitieName),
});

export default { resolver: yupResolver(validation) };
